import { createClient, type SupabaseClient } from '@supabase/supabase-js';

/**
 * Browser Supabase client, used only for Google sign-in. Configuration lives
 * in the project's Auth dashboard - this file just needs the project URL and
 * anon key.
 *
 * VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are optional: a deployment that
 * has not provisioned Supabase yet (or is running guest-only) leaves them
 * unset. `supabaseConfigured` is false in that case; callers must check it
 * before assuming `supabase` is usable, since it may be a stub that is
 * inert rather than a working client.
 */

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabaseConfigured = Boolean(url && anonKey);

export const supabase: SupabaseClient = supabaseConfigured
  ? createClient(url, anonKey)
  : createClient('https://placeholder.supabase.co', 'placeholder-anon-key');
